/**
 * Test IDs for QA automation.
 */
export const testIds = {
  qualificationFormType: "qualification-form-type",
  qualificationFormNumber: "qualification-form-number",
  qualificationFormRequired: "qualification-form-required",
  qualificationFormOpenDocument: "qualification-form-open-document",
  qualificationFormRemoveDocument: "qualification-form-remove-document",
  qualificationFormUploadDocuments: "qualification-form-upload-documents",
  qualificationFormSave: "qualification-form-save",
} as const;
